import Rest from '../Rest'

export default class LegalEntityFormLgpdService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entity_form_lgpds'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
